<script>
export default {
  name: 'UlCard',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    flex: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cls() {
      return {
        'ul-card--overflow': this.loading,
        'ul-card--flex': this.flex,
      };
    },
  },
};
</script>
<template>
  <div class="ul-card" :class="cls">
    <slot></slot>
    <UlLoad v-if="loading"></UlLoad>
  </div>
</template>
<style lang="scss">
  .ul-card {
    background-color: #FFFFFF;
    border-radius: 4px;
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14),
    0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    padding: 24px;
    position: relative;
    margin: 0 0 24px 0;

    &--overflow {
      overflow: hidden;
    }

    &--flex {
      display: flex;
      flex-direction: column;
    }
  }
</style>
